import { render, staticRenderFns } from "./install-page.vue?vue&type=template&id=120ba149&scoped=true&"
import script from "./install-page.vue?vue&type=script&lang=js&"
export * from "./install-page.vue?vue&type=script&lang=js&"
import style0 from "./install-page.vue?vue&type=style&index=0&id=120ba149&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ba149",
  null
  
)

export default component.exports